<div class="py-4 relative h-100 flex flex-col justify-between box-border">
  @if (isLoading) {
    <app-page-loading></app-page-loading>
  }

  @if (!isLoading) {
    @if (!showSummary) {
      <form #bidForm="ngForm" role="form">
        <!--        todo: review files, this is commented out because the component isn't used-->
        <!--        <app-input-upload-->
        <!--          (onFilesChange)="onFilesChange($event)"-->
        <!--          (onUploadFinished)="setupForm()"-->
        <!--          [files]="model.files"-->
        <!--          [hideRemoveFileIcon]="true"-->
        <!--          [metaData]="uploadMetaData"-->
        <!--          [uploadFiles$]="uploadFiles"-->
        <!--        ></app-input-upload>-->
        <app-floating-input
          [(ngModel)]="model.description"
          label="Description"
          name="description"
          placeholder="Description"
          required
        ></app-floating-input>
        <app-floating-input
          [(ngModel)]="model.value"
          label="Value"
          name="value"
          placeholder="Value"
          required
          type="number"
        ></app-floating-input>
        <app-floating-input
          [(ngModel)]="model.message"
          label="Message"
          name="message"
          placeholder="Message"
          required
        ></app-floating-input>
        <div class="flex justify-end gap-3 w-full">
          @if (model?.id) {
            <app-simple-button (click)="reviseProposal()">Cancel</app-simple-button>
          }
          <app-simple-button
            [wrapperClass]="{
              'bg-yellow-500': true,
            }"
            (click)="submit(bidForm)"
            >Submit Proposal</app-simple-button
          >
        </div>
      </form>
    }

    @if (showSummary) {
      <div
        class="mt-8 pb-8 text-navy-700 font-bold flex flex-col items-center justify-center gap-6 border-b border-navy-400"
      >
        <span class="icon-paid text-5xl text-green-600"></span>
        <span class="font-bold text-size_title_s"> {{ isAwarded ? 'Project Awarded' : 'Proposal Submitted' }}</span>
        <span class="font-bold text-4xl">{{ model.value | money: 'comaSign' }}</span>
        <div class="flex justify-end gap-3">
          <app-simple-button
            (click)="downloadProposal()"
            [wrapperClass]="{
              'bg-transparent border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-color-white': true,
            }"
          >
            Download</app-simple-button
          >
          <app-simple-button (click)="reviseProposal()">Revise Proposal</app-simple-button>
        </div>
      </div>
    }
  }
</div>
